/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';
import Tile from '@atlaskit/tile/tile';
import { token } from '@atlaskit/tokens';

import { ICON_CYCLER_TEST_ID_SUFFIX } from './constants';
import IconCycler from './icon-cycler';
import type { IconComponent, SlideMorphProps } from './types';

// @atlaskit/tile's TileBackgroundColor union doesn't include color.background.input,
// so we override the background via a wrapper targeting the tile's root <span>.
const tileWrapperStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
	'& > span': {
		backgroundColor: token('color.background.input'),
	},
});

export default function SlideMorph({
	animationDisabled = false,
	icons,
	testId,
	cycleDirection = 'right',
}: SlideMorphProps): JSX.Element {
	const iconsWithProps = icons.map(
		(Icon) =>
			((props: NewCoreIconProps) => (
				<Icon color={token('color.icon.subtle')} {...props} />
			)) as IconComponent,
	);

	return (
		<div css={tileWrapperStyles}>
			<Tile
				label=""
				backgroundColor="color.background.neutral"
				hasBorder={true}
				size="xlarge"
				testId={testId}
			>
				<IconCycler
					animationDisabled={animationDisabled}
					icons={iconsWithProps}
					cycleDirection={cycleDirection}
					testId={testId ? `${testId}--${ICON_CYCLER_TEST_ID_SUFFIX}` : undefined}
				/>
			</Tile>
		</div>
	);
}
